import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, ToastController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';
// import { BrowserQRCodeReader } from '@zxing/library';
// import { Camera, CameraOptions } from '@ionic-native/camera';

import { LoginPage } from '../login/login';
import { TransfercompletePage } from '../transfercomplete/transfercomplete';
import { TransferconfirmPage } from '../transferconfirm/transferconfirm';

/**
 * Generated class for the TransferPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-transfer',
  templateUrl: 'transfer.html',
})
export class TransferPage {
    @ViewChild('Id') Id;

    loginId: string;
	api_key: string;
	version: string;
	email: string;

	balance: string;
	idx: string;
	id: string;
	name: string;
	value: string;
    coin_unit: string;
    unit: string;
    
    texts: any = [];
	language : string;
	imagePath:string;

    isSend : boolean = true;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		public modalCtrl: ModalController,
		public alertCtrl:AlertController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
		public app: App
    ) {
	
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "transfer");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
        this.email = localStorage.getItem("email");
        this.coin_unit = localStorage.getItem("coin_unit");
        this.unit = localStorage.getItem("unit");

        this._get_texts();

        this._init();

        setTimeout(() => {
			this.Id.setFocus();
		},500);
        
    }

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).transfer;
	}

    keyDown(event) {
        // if (this.value == undefined || this.value == null) {
		// 	var tmps: string = "";
		// } else {
		// 	tmps = this.value;
		// }
		
        // this.value = tmps.replace(/[^0-9.]/g, "");

        let pattern = /^\d*[.]\d*$/; 
        var tmps = this.value.replace(/[^0-9.]/g, "");
        if (pattern.test(tmps)) {
            if (event.keyCode == 110 || event.keyCode == 190) {
                    return false;
            }
        }
        
    }

    keyUp() {
        if(this.value != null || this.value != "") {
            var tmps = this.value.replace(/[^0-9.]/g, "");    
			var parts: any = tmps.toString().split(".");
			var floats: any = tmps.toString().indexOf(".");
			var tron = Number(this.balance.replace(/[^0-9.]/g, ""));

			if(floats == -1){
                if(parts[0].length > 20) parts[0] = parts[0].substr(0, 20);
                parts[0] = parts[0] * 1;                         
			    if(parts[0] == 0) parts[0] = '0';
				if (parts[0] > tron) {
					this.value = this.balance;
					
				} else {
					parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");  
					this.value = parts[0];
				}
			}else{
				if(parts[0].length > 13) parts[0] = parts[0].substr(0, 13);
				if(parts[1].length > 8) parts[1] = parts[1].substr(0, 8);
                var tmp1 = Number(parts.join("."));
				if (tmp1 > tron) {
					this.value = this.balance;
					
				} else {
					parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                	this.value = parts.join(".");
				}
			}
        }
	}
	
	_init() {
        this.value = '';
        
        //// 서버로부터의 데이타
        let url = "p2p/send";
        let body = JSON.stringify({ 
            api: this.api_key,
            language: this.language,
            version: this.version
        });
        this.http.post(url, body).then((res: any) => {
            if(res.result=="OK"){
                this.balance = res.balance;

            } else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                this.navCtrl.pop();

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);
            
            } else {
                this.navCtrl.pop();
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
            
        },(err)=>{	
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
        
        });
	}

	_apply(){
        this.isSend = false;

		if (!this.id || this.id.length == 0) {
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_id,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            this.isSend = true;
            return ;
        }

        if (!this.name || this.name.length == 0) {
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_name,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            this.isSend = true;
            return ;
        }

        if (!this.value || this.value.length == 0) {
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_amount,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            this.isSend = true;
            return ;
        }

        // this.navCtrl.push(StakingconfirmPage, {value: this.value});

        let modal = this.modalCtrl.create(TransferconfirmPage, {idx: this.idx, id: this.id, name: this.name, value: this.value});
        modal.present();

        modal.onDidDismiss( data => {
            if (data == 'ok') {
                this.isSend = true;
                this.navCtrl.pop();
            } else {
                this.isSend = true;
                this._init();
            }

        });

        // modal.onDidDismiss( data => {
        //     if (data != '') {
        //         this.isSend = true;

        //         let url = "staking/base/index/save";
        //         let body = JSON.stringify({ 
        //             api: this.api_key,
        //             language: this.language,
        //             version: this.version,
        //             date: data.date,
        //             start: data.start,
        //             end: data.end,
        //             value: data.value,
        //             idx: data.idx,
        //         });
        //         this.http.post(url, body).then((res: any) => {
        //             if(res.result=="OK"){
        //                 this.navCtrl.pop();
        //                 let modal = this.modalCtrl.create(StakingcompletePage);
        //                 modal.present();

        //             } else if(res.result ==="DONOT"){
        //                 let alert = this.alertCtrl.create({
        //                     message: res.message,
        //                     buttons: ['OK']
        //                 });
        //                 alert.present();
        //                 this.navCtrl.pop();

        //             } else if(res.result ==="LOGOUT"){
        //                 let alert = this.alertCtrl.create({
        //                     message: res.message,
        //                     buttons: ['OK']
        //                 });
        //                 alert.present();
        //                 localStorage.removeItem("loginId");
        //                 localStorage.removeItem("api_key");
        //                 this.app.getRootNav().setRoot(LoginPage);
                    
        //             } else {
        //                 this.navCtrl.pop();
        //                 let alert = this.alertCtrl.create({
        //                     message: res.message,
        //                     buttons: ['OK']
        //                 });
        //                 alert.present();
        //             }
                    
        //         },(err)=>{	
        //             //// HTTP 에러인 경우
        //             let alert = this.alertCtrl.create({
        //                 message: err,
        //                 buttons: ['OK']
        //             });
        //             alert.present();
                
        //         });
                

        //     } else {
        //         this.isSend = true;
        //         this._init();
        //     }
        // });
	}

    _search(id) {
        this.name = '';

        //// 서버로부터의 데이타
        let url = "p2p/send/index/member";
        let body = JSON.stringify({ 
            api: this.api_key,
            language: this.language,
            version: this.version,
            id: id,
        });
        this.http.post(url, body).then((res: any) => {
            if(res.result=="OK"){
                this.name = res.name;
                this.idx = res.idx;

            } else if(res.result ==="NO"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();

            } else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                this.navCtrl.pop();

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);
            
            } else {
                this.navCtrl.pop();
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
            
        },(err)=>{	
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
        
        });
    }

    _cancel() {
        this.navCtrl.pop();
    }
}



// WEBPACK FOOTER //
// ./src/pages/transfer/transfer.ts